/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { PackageSelectionMethodType } from './package-selection-method-type';
import { PackageStatusType } from './package-status-type';
import { PointDtoModel } from '@irian-ro/util-functions';
import { PackageStateModel } from './package.state.model';

export class PackageLatestEventVO {
  uuid: string | undefined = undefined;
  pieceId: string | undefined = undefined;
  statusType: PackageStatusType | undefined = undefined;
  type: string | undefined = undefined;
  timestamp: Date | undefined = undefined;
  street: string | undefined = undefined;
  streetNumber: string | undefined = undefined;
  postalCode: string | undefined = undefined;
  city: string | undefined = undefined;
  country: string | undefined = undefined;
  namedLocationLabel: string | undefined = undefined;
  pointVO: PointDtoModel | undefined = undefined;
  state: PackageStateModel | undefined = undefined;
  packageSelectionMethodType: PackageSelectionMethodType | undefined = undefined;
  deliveryTimeWindowEnd: Date | undefined = undefined;
  deliveryTimezone: string | undefined = undefined;
}
